"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Input = _interopRequireDefault(require("./Input"));

var _Select = _interopRequireDefault(require("./Select"));

var _PostTreeSelect = _interopRequireDefault(require("./PostTreeSelect"));

var _store = require("../store"); // import app components


var PostForm = function PostForm(props) {
  var _sites$siteID, _sites$siteID$postTyp, _sites$siteID$postTyp2, _sites$siteID2;

  var defaultPostTypeID = props.postTypeID,
      onSubmit = props.onSubmit;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$0$cmsState = _ref2[0].cmsState,
      sites = _ref2$0$cmsState.sites,
      siteID = _ref2$0$cmsState.siteID,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      title = _ref4[0],
      setTitle = _ref4[1];

  var _ref5 = (0, _react.useState)(defaultPostTypeID || 'page'),
      _ref6 = _slicedToArray(_ref5, 2),
      postTypeID = _ref6[0],
      setPostTypeID = _ref6[1];

  var _ref7 = (0, _react.useState)(0),
      _ref8 = _slicedToArray(_ref7, 2),
      parentID = _ref8[0],
      setParentID = _ref8[1];

  var posts = (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$postTyp = _sites$siteID.postTypes) === null || _sites$siteID$postTyp === void 0 ? void 0 : (_sites$siteID$postTyp2 = _sites$siteID$postTyp[postTypeID]) === null || _sites$siteID$postTyp2 === void 0 ? void 0 : _sites$siteID$postTyp2.posts;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (title) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return onSubmit({
                postTypeID: postTypeID,
                title: title,
                parentID: parentID
              });

            case 4:
              setTitle('');
              setParentID(0);
              dispatch({
                type: 'CLOSE_DIALOG'
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref9.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: title,
    onChange: function onChange(e) {
      return setTitle(e.target.value);
    },
    placeholder: '',
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    }
  }), !defaultPostTypeID && ((_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.postTypes) && Object.values(sites[siteID].postTypes).length > 1 && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Post Type",
    value: postTypeID,
    onChange: function onChange(v) {
      return setPostTypeID(v);
    }
  }, Object.values(sites[siteID].postTypes).map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.id,
      value: o.id,
      children: o.title
    });
  })), postTypeID === 'page' && /*#__PURE__*/_react.default.createElement(_PostTreeSelect.default, {
    label: "Parent",
    items: Object.values(posts),
    value: parentID,
    onChange: function onChange(value) {
      return setParentID(value);
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Add",
    onClick: handleSubmit,
    type: "primary",
    disabled: !title
  }));
};

var _default = PostForm;
exports.default = _default;